import { sessionQueryOptions } from '@/lib/session-query';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/` — session-aware entry router.
 *
 * We don't render anything at the root: the route resolves to either
 * `/hills` (authenticated) or `/login` (not). Doing the decision in
 * `beforeLoad` — not in a component with `useEffect` — avoids a flash
 * of unstyled redirect.
 */
export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions());
    throw redirect({ to: session ? '/hills' : '/login' });
  },
});
